var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 4.16675C3.33301 2.78604 4.4523 1.66675 5.83301 1.66675H10.6308C11.2938 1.66675 11.9297 1.93014 12.3986 2.39898L15.9341 5.93451C16.4029 6.40336 16.6663 7.03924 16.6663 7.70228V15.8334C16.6663 17.2141 15.5471 18.3334 14.1663 18.3334H5.83301C4.4523 18.3334 3.33301 17.2141 3.33301 15.8334V4.16675ZM14.1663 17.3334H5.83301C5.00458 17.3334 4.33301 16.6618 4.33301 15.8334V4.16675C4.33301 3.33832 5.00458 2.66675 5.83301 2.66675H10.6308C10.6706 2.66675 10.7102 2.66833 10.7496 2.67146V5.83342C10.7496 6.79991 11.5331 7.58342 12.4996 7.58342H15.6616C15.6648 7.62282 15.6663 7.66247 15.6663 7.70228V15.8334C15.6663 16.6618 14.9948 17.3334 14.1663 17.3334ZM15.1688 6.58342L11.7496 3.16421V5.83342C11.7496 6.24763 12.0854 6.58342 12.4996 6.58342H15.1688Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.85218 12.4857V14.6753C8.85218 14.7514 8.82194 14.8244 8.76811 14.8782C8.71428 14.9321 8.64127 14.9623 8.56515 14.9623H7.78704C7.71091 14.9623 7.6379 14.9321 7.58407 14.8782C7.53024 14.8244 7.5 14.7514 7.5 14.6753V8.07341C7.5 7.99729 7.53024 7.92428 7.58407 7.87045C7.6379 7.81662 7.71091 7.78638 7.78704 7.78638H10.2752C11.7199 7.78638 12.6667 8.74604 12.6667 10.1386C12.6667 11.5372 11.7187 12.4857 10.2699 12.4857H8.85218ZM8.85213 11.3415H9.68693C10.8308 11.3415 11.2941 11.0322 11.2941 10.1376C11.2941 9.37095 10.8607 8.93872 10.1012 8.93872H8.85213V11.3415Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptFile);
export default __webpack_public_path__ + "static/media/pptFile.9bf7862ee3ddf925c43f2326425fcb24.svg";
export { ForwardRef as ReactComponent };